//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      title: "ميزات إنشاء تطبيق متجر الكتروني على منصة تجدد ",
      description: "احصل على تطبيق متجر الكتروني احترافي بمميزات لا محدودة وتصاميم احترافية وبواجهات فريدة لا تتشابه مع تطبيق آخر",

      sliderElements: [
        {
          title: "القصص التفاعلية",
          imageUrl: "/assets/images/features/slider-elements/01.png",
        },
        {
          title: "صفحات مخصصة",
          imageUrl: "/assets/images/features/slider-elements/02.png",
        },
        {
          title: "عرض أفقي ورأسي للمنتجات",
          imageUrl: "/assets/images/features/slider-elements/03.png",
        },
        {
          title: "النوافذ المنبثقة",
          imageUrl: "/assets/images/features/slider-elements/04.png",
        },
        {
          title: "شريط الأقسام المتحرك",
          imageUrl: "/assets/images/features/slider-elements/05.png",
        },
        {
          title: "العداد التنازلي للعروض",
          imageUrl: "/assets/images/features/slider-elements/06.png",
        },

      ],
      sliderFeatures: [
        {
          title: "إشعارات بتحديثات الطلبات",
          details: "",
          imageUrl: "/assets/images/features/slider-features/01.png",
        },
        {
          title: "تصفح أسهل للمنتجات",
          details: "من خلال التطبيق يمكن لعملاء متجرك التصفح الأسهل والأسرع للمنتجات بكل سهولة",
          imageUrl: "/assets/images/features/slider-features/02.png",
        },
        {
          title: "متابعة الطلبات",
          details: "امكانية متابعة الطلبات والشحنات من طرف عملاء المتجر بكل سهولة",
          imageUrl: "/assets/images/features/slider-features/03.png",
        },
        {
          title: "سلة التسوق",
          details: "إضافة المشتريات للسلة، إدارة سلة المشتريات، إكمال عملية الشراء والدفع، متابعة حالة الطلب",
          imageUrl: "/assets/images/features/slider-elements/04.png",
        },
        {
          title: "المفضلة",
          imageUrl: "/assets/images/features/slider-features/05.png",
        },
        {
          title: "الدفع الاونلاين",
          details: "تجربة سهلة لاتمام الطلب والدفع من خلال التطبيق عن طريق الفيزا كارد أو أبل باي",
          imageUrl: "/assets/images/features/slider-features/06.png",
        },

      ],
    };
  },
  head() {
    return {
      title: this.title,
      description: this.description,
      keywords: 'انشاء متجر الكتروني, تصميم متجر الكتروني, تجهيز متجر الكتروني',
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:locale", // open graph type
          property: "og:locale",
          content: "ar_AR",
        },
        {
          hid: "og:type", // open graph type
          property: "og:type",
          content: "article",
        },
        {
          hid: "og:title", // open graph title
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description", // open graph description
          property: "og:description",
          content: this.description,
        },
        {
          hid: "og:url", // open graph url
          property: "og:url",
          content: "https://tajadad.app/features",
        },
        {
          hid: "og:site_name", // open graph site_name
          property: "og:site_name",
          content: "متجرة",
        },
        {
          hid: "og:updated_time", // open graph updated_time
          property: "og:updated_time",
          content: "2022-12-10T00:08:47+03:00",
        },
        {
          hid: "og:image", // open graph image
          property: "og:image",
          content:
            "https://tajadad.app/tajadad.jpg",
        },
        {
          hid: "apple-mobile-web-app-title", // open graph mobile web app title
          name: "apple-mobile-web-app-title",
          content: this.title,
        },

        // open graph twitter
        { name: "twitter:site", content: "@Tajadad" },
        { name: "twitter:card", content: "summary_large_image" },
        {
          hid: "twitter:url",
          name: "twitter:url",
          content: "https://tajadad.app/features",
        },
        {
          hid: "twitter:title",
          name: "twitter:title",
          content: this.title,
        },
        {
          hid: "twitter:description",
          name: "twitter:description",
          content: this.description,
        },
        {
          hid: "twitter:image",
          name: "twitter:image",
          content:
            "https://tajadad.app/tajadad.jpg",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://tajadad.app/features",
        },
      ],
    };
  },
  jsonld() {
    return {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Article",
          "headline": this.title,
          "description": this.description,
          "datePublished": '2022-10-14T10:10:00-07:00',
          "dateModified": '2022-10-14T10:10:00-07:00',
          "publisher": {
            "@type": "Organization",
            "name": "منصة متجرة",
            "logo": {
              "@type": "ImageObject",
              "url": "https://tajadad.app/tajadad.jpg",
            }
          },
          "mainEntityOfPage": {
            "@type": "WebPage",
            "@id": "https://tajadad.app/store-app"
          },
          "author": { "@type": "Person", "name": "matjrah" },
        }]
    }
  }
};
